import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./OnboardingEmployeeDetails.css";

const OnboardingEmployeeDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const application = state?.application || {};
  const personalInfo = application.personalInformation || {};
  const [onboardingDate, setOnboardingDate] = useState(null);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const dateInputRef = useRef(null);
  const today = new Date();
  const maxDate = today.toISOString().split("T")[0]; // No future dates

  // Validate onboarding date
  const isValidDate = onboardingDate !== null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidDate) {
      setError("Onboarding date is required.");
      return;
    }

    const formattedDate = onboardingDate
      ? new Date(onboardingDate).toLocaleDateString("en-CA")
      : "";

    const payload = {
      employeeUniqueId: personalInfo.employeeUniqueId || "",
      firstName: personalInfo.givenName || "",
      lastName: personalInfo.surname || "",
      jobPosition: personalInfo.employee.jobPosition?.designationName || "",
      l1VerifiedBy: true,
      l2VerifiedBy: true,
      dateOfJoining: formattedDate,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/onboarding`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );
      setSuccessMessage("Onboarding details submitted successfully!");
      setError("");
      setTimeout(() => {
        navigate("/onboardingEmployessList");
      }, 2000);
    } catch (err) {
      console.error("Failed to submit onboarding details:", err);
      setError(
        err.response?.data?.error || "Failed to submit onboarding details."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/onboardingEmployessList");
  };

  return (
    <div className="onboarding-details-container">
      <h2>Onboarding Details</h2>
      <div className="onboarding-details-table">
        <table>
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Temporary ID</td>
              <td>{personalInfo.employeeUniqueId || "N/A"}</td>
            </tr>
            <tr>
              <td>Employee Name</td>
              <td>
                {`${personalInfo.givenName || ""} ${personalInfo.surname || ""}`.trim() || "N/A"}
              </td>
            </tr>
            <tr>
              <td>Position Name</td>
              <td>{personalInfo.employee.jobPosition?.designationName || "N/A"}</td>
            </tr>
            <tr>
              <td>Verification L1</td>
              <td>{true ? "Verified" : "Not Verified"}</td>
            </tr>
            <tr>
              <td>Verification L2</td>
              <td>{true ? "Verified" : "Not Verified"}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="onboarding-date-container">
          <div className="onboarding-floating-label-container">
            <DatePicker
              selected={onboardingDate}
              onChange={(date) => {
                setOnboardingDate(date);
                setError("");
              }}
              dateFormat="dd-MM-yyyy"
              placeholderText=""
              className="did-floating-input-on-emp"
              ref={dateInputRef}
              //maxDate={new Date(maxDate)}
             // showYearDropdown
              //scrollableYearDropdown
              //yearDropdownItemNumber={10}
            />
            <label className={onboardingDate ? "float" : ""}>
              <span className="required">*</span>Onboarding Date
            </label>
            {error && <p className="error">{error}</p>}
          </div>
        </div>
        <div className="onboarding-btn-div">
          <button
            type="button"
            className="onboarding-cancel"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="onboarding-submit"
            disabled={!isValidDate || loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
        {successMessage && (
          <div className="success-message">
            <p>{successMessage}</p>
          </div>
        )}
      </form>
    </div>
  );
};

export default OnboardingEmployeeDetails;